<template>
  <div class="container">
    <div
      style="display: flex; align-items: center; gap: 16px; margin-bottom: 16px"
    >
      <a-button type="primary" @click="openAdd = true" style="margin-bottom: 0">
        添加模版
      </a-button>
      <a-form layout="inline">
        <a-form-item label="搜索类别">
          <a-select
            style="min-width: 120px"
            v-model:value="listRequest.category"
          >
            <a-select-option :value="1">通用</a-select-option>
            <a-select-option :value="2">极致</a-select-option>
            <a-select-option :value="3">简约</a-select-option>
            <a-select-option :value="4">生日</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleList">搜索</a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-table
      :columns="columns"
      :data-source="templateList"
      :pagination="{
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      }"
      bordered
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'category'">
          <span v-if="record.category === 1">通用</span>
          <span v-if="record.category === 2">极致</span>
          <span v-if="record.category === 3">简约</span>
          <span v-if="record.category === 4">生日</span>
        </template>
        <template v-else-if="column.dataIndex === 'image_url'">
          <a-image
            :src="ToImage(record.image_url)"
            style="height: 60px; width: auto"
          />
        </template>
        <template v-else-if="column.dataIndex === 'is_delete'">
          <a-tag v-if="record.is_delete === 1" color="green">正常</a-tag>
          <a-tag v-if="record.is_delete === 2" color="red">回收站</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'create_at'">
          <span
            >{{ dayjs(record.create_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'operator'">
          <a-button
            @click="handleUpdate(record)"
            type="primary"
            :style="{ marginRight: '8px' }"
            >编辑
          </a-button>
          <a-button
            @click="submitDelete(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }"
            >删除
          </a-button>
          <a-button
            @click="submitDrop(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff4d4f',
              color: 'white',
            }"
            >彻底删除
          </a-button>
        </template>
      </template>
    </a-table>
    <a-modal
      v-model:open="openAdd"
      title="添加模版数据"
      @ok="submitAdd"
      cancelText="取消"
    >
      <a-form :model="addRequest">
        <a-form-item label="模版名称">
          <a-input v-model:value="addRequest.name" />
        </a-form-item>
        <a-form-item label="优先级">
          <a-input-number v-model:value="addRequest.level" />
        </a-form-item>
        <a-form-item label="价格">
          <a-input-number v-model:value="addRequest.price" />
        </a-form-item>
        <a-form-item label="类别">
          <a-select v-model:value="addRequest.category">
            <a-select-option :value="1">通用</a-select-option>
            <a-select-option :value="2">极致</a-select-option>
            <a-select-option :value="3">简约</a-select-option>
            <a-select-option :value="4">生日</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="图片">
          <File-Upload v-model="addRequest.image_url" style="display: block" />
          <a-image
            v-if="addRequest.image_url !== ''"
            :src="ToImage(addRequest.image_url)"
            style="max-height: 150px; display: block; margin-top: 10px"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-model:open="openUpdate"
      title="修改模版数据"
      @ok="submitUpdate"
      cancelText="取消"
    >
      <a-form :model="updateRequest" style="margin-top: 20px">
        <a-form-item label="模版名称">
          <a-input v-model:value="updateRequest.name" />
        </a-form-item>
        <a-form-item label="优先级">
          <a-input-number v-model:value="updateRequest.level" />
        </a-form-item>
        <a-form-item label="类别">
          <a-select v-model:value="updateRequest.category">
            <a-select-option :value="1">通用</a-select-option>
            <a-select-option :value="2">极致</a-select-option>
            <a-select-option :value="3">简约</a-select-option>
            <a-select-option :value="4">生日</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model:value="updateRequest.is_delete">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">回收站</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="图片">
          <File-Upload
            v-model="updateRequest.image_url"
            style="display: block"
          />
          <a-image
            :src="ToImage(updateRequest.image_url)"
            style="max-height: 150px; display: block; margin-top: 10px"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import { ToImage } from "@/utils/image";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import FileUpload from "@/components/FileUpload.vue";
import { Template } from "@/api/models/template/Template";
import { TemplateService } from "@/api/services/TemplateService";
import { TemplateAddRequest } from "@/api/models/template/TemplateAddRequest";
import { TemplateUpdateRequest } from "@/api/models/template/TemplateUpdateRequest";
import { TemplateListRequest } from "@/api/models/template/TemplateListRequest";

const total = ref<number>(0);

const listRequest = reactive<TemplateListRequest>({
  current: 1,
  size: 20,
  content: "",
});

const templateList = ref<Template[]>([]);

const handleList = async () => {
  const res = await TemplateService.ListAll(listRequest);
  if (res.code === 0) {
    templateList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<TemplateAddRequest>({
  name: "",
  image_url: "",
  level: 1,
  price: 0,
  category: 1,
});

const submitAdd = async () => {
  const res = await TemplateService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<TemplateUpdateRequest>({
  id: 0,
  name: "",
  image_url: "",
  level: 0,
  is_delete: 0,
  price: 0,
  category: 0,
});

const handleUpdate = (record: Template) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await TemplateService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Template) => {
  const res = await TemplateService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Template) => {
  const res = await TemplateService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "模版名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "排序",
    dataIndex: "level",
    align: "center",
  },
  {
    title: "模版分类",
    dataIndex: "category",
    align: "center",
  },
  {
    title: "图片",
    dataIndex: "image_url",
    align: "center",
  },
  {
    title: "价格",
    dataIndex: "price",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
}
</style>
